import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IForecastForReceiptRepository } from '@/coreInfrastructureModule/interfaces/IForecastForReceiptManage';
import { IForecastForReceiptList } from '../domains/entities/forecastForReceiptList';
import { GetForecastForReceiptAdapter } from '../adapter/getForecastForReceiptAdapter';

/**
 * 受領用内示を取得するUseCase
 */
export class GetForecastForReceiptUseCase {
  /**
   * 受領用内示を取得する
   * @param repository - リポジトリ
   */
  public Execute = async (repository: IForecastForReceiptRepository): Promise<INetworkResult<IForecastForReceiptList, Error>> => {
    try {
      const result = await repository.getForecastForReceipt();

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      const data = GetForecastForReceiptAdapter.adaptForResponse(result.status.data);

      return {
        status: {
          type: 'success',
          data: data,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  };
}
